"use client"

import "@/src/extensions/number"
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import ChooseHalfFlavors from './choose-half-flavors/choose-half-flavors'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import SvgPlus from '@/src/assets/svgs/collection/plus.svg'
import SvgPencil from '@/src/assets/svgs/collection/pencil.svg'
import SvgCheck from '@/src/assets/svgs/collection/check-color.svg'
import SvgTrash from '@/src/assets/svgs/collection/trash.svg'
import ChooseHalfComplements from "./choose-half-complements/choose-half-complements"
import ImageFallback from "@/src/components/helpers/image-fallback/image-fallback"
import Modal from "@/src/components/helpers/overlays/modal/modal"
import { Overlay } from "@/src/components/helpers/overlays/overlay"
import { CustomSize, useCurrentProduct } from "@/src/context/product/current-product-context"
import ItemInfos from "@/src/interfaces/catalog/item-infos"
import Group from "../../wizard/question/group"
import { ItemService } from "@/src/services/catalog/item-service"
import LoadingComplements from "./loading-complements/loading-complements"
import { useCalculationProduct } from "@/src/hooks/product/calculation"
import "@/src/extensions/number"
import { usePromotion } from "@/src/context/promotion/promotion-context"
import { PromotionHelper } from "@/src/helpers/promotion"
import { useAppAccessToken } from "@/src/context/app-access-token/app-access-token-context"
import { useMessage } from "@/src/context/message/message-context"

export interface CurrentHalfSelectedComplements {
    id: string
    name: string
    sizeComplements: ItemInfos.Complement[]
}

interface Props {
    sizeChosen: ItemInfos.Size
    moveBack: () => void
}

export default function ConfigProductBySize(props: Props) {
    const { merchantSummary, localMode } = useMerchant()
    const { getSizePrice } = useCalculationProduct()
    const { promotion } = usePromotion()
    const { appAccessToken } = useAppAccessToken()
    const { showMessage } = useMessage()

    const {
        currentProduct,
        setPrice,
        setSizeProduct,
        setTitleSizeProduct,
        sizeProduct,
        amountProducts,
        setSizeDetails,
        sizeDetails,
        answers,
        hasWizard,
        setIsLoading,
        isLoading
    } = useCurrentProduct()

    const [showModalComplement, setShowModalComplement] = useState<CurrentHalfSelectedComplements | undefined>(undefined)
    const [isModal, setIsModal] = useState(false)
    const [halfFlavors, setHalfFlavors] = useState<CustomSize[]>([])
    const [complementsByHalf, setComplementsByHalf] = useState<CurrentHalfSelectedComplements[]>([])

    const removeHalf = (item: CustomSize) => {
        setHalfFlavors(prevHalfs => prevHalfs.filter(half => half.id !== item.id))
    }

    const addHalfComplement = (item: CustomSize) => {
        const currentComplements = complementsByHalf.find(c => c.id === item.id)?.sizeComplements || []
        setShowModalComplement({ id: item.id, name: `1/${halfFlavors.length} ${item.name}`, sizeComplements: currentComplements })
    }

    const renderCurrentComplementsQuantity = (id: string): JSX.Element => {
        const currentComplements = complementsByHalf.find(c => c.id === id)?.sizeComplements || []
        return currentComplements.length > 0 ? <b>({currentComplements.length})</b> : <>[+]</>
    }

    const renderHalfs = () => {
        return (
            halfFlavors.map((item: CustomSize, index) => {
                const imgSrc = (item.hasPhoto && merchantSummary?.showProductPhoto) ? `//${item?.smallImageUrl}` : undefined

                return (
                    <div key={index} className={styles.half} id={item.id}>
                        <div className={styles.imageArea}>
                            <ImageFallback src={imgSrc} alt='' />
                        </div>
                        <div className={styles.descriptionArea}>
                            <span className={styles.halfTitle}>1/{halfFlavors.length} {item.name}</span>
                            {
                                (sizeDetails && !hasWizard) &&
                                <span className={`${styles.halfAddComplement} font-sm`} onClick={() => addHalfComplement(item)}>
                                    Complementos para sabor {renderCurrentComplementsQuantity(item.id)}
                                </span>
                            }
                        </div>
                        {
                            item.id !== props.sizeChosen.itemId &&
                            <div className={styles.imageDeleteArea}>
                                <SvgTrash onClick={() => removeHalf(item)} />
                            </div>
                        }
                    </div>
                )
            })
        )
    }

    const renderAddFlavor = (hasFlavor: boolean) => {
        if (isLoading) return <></>

        let label = 'Adicionar sabor'

        if (props.sizeChosen.maxQtyParts === halfFlavors.length)
            label = 'Trocar sabor'

        return (
            <div onClick={() => setIsModal(true)} className={hasFlavor ? styles.hasAddFlavor : styles.addFlavor}>
                <div className={styles.plusIcon}>
                    <SvgPlus />
                </div>
                <span>{label}</span>
            </div>
        )
    }

    const addItemToContext = () => {
        if (halfFlavors.length < 2) {
            if (currentProduct) {
                const principalItem: Partial<CustomSize> = {
                    ...props.sizeChosen,
                    description: currentProduct.description || "",
                    detailsExternalId: props.sizeChosen.productDetailsExternalId,
                    externalId: currentProduct.productExternalId,
                    salePrice: props.sizeChosen.salePrice,
                    quantity: amountProducts,
                    sizesSelected: [],
                    complementsSelecteds: complementsByHalf.find(c => c.id === props.sizeChosen.id)?.sizeComplements || [],
                    sizeType: props.sizeChosen.sizeType
                }

                setSizeProduct(principalItem)
            }
        }
        else {
            let principalItem = sizeProduct || {} as CustomSize

            principalItem.name = `${props.sizeChosen.sizeType.name} ${props.sizeChosen.name}`
            principalItem.salePrice = 0
            principalItem.isGroup = true

            const addedSizes: CustomSize[] = halfFlavors.map(item => {
                const currentComplements = complementsByHalf.find(c => c.id === item.id)?.sizeComplements || []
                const newQty = (1 / halfFlavors.length)

                return {
                    ...item,
                    quantity: newQty.customRound(4),
                    complementsSelecteds: currentComplements
                }
            })

            principalItem.sizesSelected = addedSizes
            setSizeProduct(principalItem)
        }
    }

    const updatePrice = () => {
        if (sizeProduct) {
            let totalPrice = getSizePrice(sizeProduct, answers, halfFlavors, complementsByHalf)
            setPrice(totalPrice)
        }
    }

    useEffect(() => {
        if (halfFlavors.length > 1) {
            setTitleSizeProduct(`${props.sizeChosen.sizeType.name} ${props.sizeChosen.name}`)
        }
        else {
            if (halfFlavors.length === 1 && halfFlavors[0].id === props.sizeChosen.itemId)
                setHalfFlavors([])
            else
                setTitleSizeProduct(undefined)
        }
    }, [halfFlavors])

    useEffect(() => {
        updatePrice()
    }, [sizeProduct, halfFlavors, complementsByHalf, answers])

    useEffect(() => {
        addItemToContext()
    }, [sizeDetails, halfFlavors, complementsByHalf, amountProducts])

    useEffect(() => {
        async function getProductDetails() {
            try {
                if (!merchantSummary?.id)
                    return

                setIsLoading(true)

                const params: ItemInfos.DetailedSearchParams = {
                    id: props.sizeChosen.itemId,
                    merchantId: merchantSummary?.id,
                    includeWizard: true,
                    sellLocal: !!localMode,
                }

                const response = await ItemService.getDetailed(params, appAccessToken)

                if (response.status === 404) {
                    Overlay.dismiss()
                    return showMessage('Item não encontrado.', { type: 'danger' })
                }

                if (!response.success || !response.model)
                    throw Error(response.errorMessage)

                const salePrice = response.model.salePrice

                if (promotion) {
                    response.model.originalPrice = salePrice
                    response.model.salePrice = PromotionHelper.getFromToPrice(promotion, { salePrice: salePrice, id: response.model.id }).to
                    response.model.promoId = PromotionHelper.getPromotionByProductId(promotion, response.model.id)?.id
                    response.model.promoPriceType = PromotionHelper.getProduct(promotion, response.model.id)?.valueType
                }

                setSizeDetails(response.model)
            }
            catch (e) {
                const error = e as Error
                console.error(error.message)
            }
            finally {
                setIsLoading(false)
            }
        }

        getProductDetails()
    }, [merchantSummary, props.sizeChosen])

    return (
        <>
            {
                showModalComplement &&
                <Modal
                    isOpen={!!showModalComplement}
                    onClose={() => setShowModalComplement(undefined)}
                    options={{ enableCloseButton: false }}
                    isInterceptRouting={false}
                >
                    <ChooseHalfComplements
                        halfId={showModalComplement.id}
                        halfTitle={showModalComplement.name}
                        quantityOfParts={halfFlavors.length}
                        complementsSelected={showModalComplement.sizeComplements}
                        handleComplements={e => {
                            const updatedList = complementsByHalf.filter(c => c.id !== e.id).concat(e)
                            setComplementsByHalf(updatedList)
                        }}
                        moveBack={() => { updatePrice(); addItemToContext(); setShowModalComplement(undefined); Overlay.dismiss() }}
                    />
                </Modal>
            }
            {
                isModal &&
                <Modal
                    isOpen={isModal}
                    onClose={() => setIsModal(false)}
                    options={{ enableCloseButton: false }}
                    isInterceptRouting={false}
                >
                    <ChooseHalfFlavors
                        maxParts={props.sizeChosen.maxQtyParts}
                        selectedItemId={props.sizeChosen.itemId}
                        sizeId={props.sizeChosen.id}
                        halfsSelected={halfFlavors}
                        getFlavors={e => setHalfFlavors(e)}
                        moveBack={() => setIsModal(false)}
                    />
                </Modal>
            }
            <div className={styles.container}>
                <div className={styles.infoSizesArea}>
                    <div className={styles.sizeChosen}>
                        <div className={styles.sizeChosenLeft}>
                            <div className={styles.sizeChosenRound}>
                                <SvgCheck />
                                <h5 className='font-xmd'>{props.sizeChosen.acronym}</h5>
                            </div>
                            <span className={`${styles.sizeChosenTitle} font-sm`}>{props.sizeChosen.name}</span>
                        </div>
                        {
                            !isLoading &&
                            <div onClick={() => props.moveBack()} className={styles.sizeChosenRight}>
                                <div className={styles.pencil}>
                                    <SvgPencil />
                                </div>
                                <span className='font-sm'>Alterar</span>
                            </div>
                        }
                    </div>
                </div>
                {
                    props.sizeChosen.maxQtyParts > 1 &&
                    <div className={styles.addFlavorArea}>
                        <h5 className={`${styles.addFlavorTitle} font-md`}>Personalizar sabores <span>{`(Opcional - até ${props.sizeChosen.maxQtyParts} sabores)`}</span></h5>
                        {
                            halfFlavors.length > 0 ?
                                <div className={styles.halfFlavors}>
                                    {renderHalfs()}
                                    {renderAddFlavor(true)}
                                </div>
                                : renderAddFlavor(false)
                        }
                    </div>
                }
            </div>
            {
                isLoading ?
                    <LoadingComplements />
                    :
                    <div className={styles.sizeWithWizard}>
                        <Group sizeDetails={sizeDetails} />
                    </div>
            }
        </>
    )
}